import { Icon } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { DARK_GREEN, LIGHT_GREEN } from "@/css/constants";

type SessionStatus = "Completed" | "Upcoming" | "Missed";

const SESSION_STATUS_STYLES: Record<
  SessionStatus,
  {
    textColor: string;
    color: string;
    icon: React.ReactNode;
  }
> = {
  ["Completed"]: {
    textColor: DARK_GREEN,
    color: LIGHT_GREEN,
    icon: <Icon icon="tick-circle" size={14} color={DARK_GREEN} />,
  },
  ["Upcoming"]: {
    textColor: "#778397",
    color: "rgba(7, 25, 86, 0.04)",
    icon: <Icon icon="time" size={14} color={"#778397"} />,
  },
  ["Missed"]: {
    textColor: "#C61D1D",
    color: "#F5E6E8",
    icon: <Icon icon="cross-circle" size={14} color={"#C61D1D"} />,
  },
};

export function StatusBadge({
  status,
  text,
  tooltip,
  icon,
}: {
  status: SessionStatus;
  text: number;
  tooltip?: string;
  icon?: React.ReactNode;
}) {
  const statusStyle = SESSION_STATUS_STYLES[status || "Upcoming"];

  if (tooltip) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className="rounded-md p-1 flex items-center gap-1"
            style={{ backgroundColor: statusStyle.color }}
          >
            {icon || statusStyle.icon}
            <div
              css={{
                color: statusStyle.textColor,
              }}
              className="font-medium text-sm"
            >
              {text}
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    );
  }

  return (
    <Flex
      css={{
        backgroundColor: statusStyle.color,
        padding: "2px 4px",
        borderRadius: 4,
        gap: 8,
        width: "fit-content",
      }}
      alignItems="center"
    >
      {statusStyle.icon}
      <Box
        css={{ fontSize: 16, color: statusStyle.textColor, fontWeight: 600 }}
      >
        {text}
      </Box>
    </Flex>
  );
}
